var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draggable-button",style:({ top: _vm.buttonPosition.top + 'vh', left: _vm.buttonPosition.left + 'vw' }),on:{"mousedown":_vm.startDrag,"touchstart":_vm.startDrag}},[_c('button',{staticClass:"mobile-button",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.iconClass})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617a9b5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/buttons/NxDraggableButton.vue
// module id = null
// module chunks = 